import {KpiInfo, ValidationError, Validator} from "../../../../../types/types";

export class SqlQueryConfigurationValidator implements Validator<KpiInfo> {
    validate(info: KpiInfo): ValidationError[] {
        const errors: ValidationError[] = [];
        const isEmpty = info.configuration.queries.length === 0;
        if (isEmpty) {
            errors.push(new ValidationError("Query", "Please add a query to proceed to next step..."))
        }

        if (!isEmpty) {
            info.configuration.queries.forEach(query => {
                const error = this.validateQuery(info.executionMode, query.query, query.name);
                if (error) {
                    errors.push(error);
                }
            })
        }
        return errors;
    }

    validateQuery(executionMode: "SPLIT" | 'BATCH', query: string, name?: string): ValidationError | false {
        const messageSuffix = name ? ` for query '${name}'` : "";
        if (executionMode === "SPLIT" && (!/([:])loginId+\b/.test(query))) {
            return new ValidationError("Query", "Could not find Split query filter ':loginId'" + messageSuffix)
        }
        if (executionMode === "BATCH" && !(/([:])loginIds+\b/.test(query))) {
            return new ValidationError("Query", "Could not find Batch query filter ':loginIds'" + messageSuffix);
        }
        return false;
    }
}